import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { btlApplicationFormApi } from '@api/btlApplicationForm/btlApplicationFormApi';
import { Borrower } from '@api/btlApplicationForm/types';

export const useBorrower = (caseId?: string): UseQueryResult<Borrower> =>
  useQuery({
    queryKey: ['btl-application-borrower', caseId],
    queryFn: () => (caseId ? btlApplicationFormApi.getBorrower(caseId) : Promise.reject()),
    enabled: !!caseId,
    retry: false,
    refetchOnWindowFocus: false,
  });
